import React from "react";
import Logo from "../../images/Avanse-Education-Loans-Logo.png";
import { MenuUnfoldOutlined } from "@ant-design/icons";
import { Col, Row } from "react-bootstrap";
import { Drawer, Popover } from "antd";
import { NavLink as Link } from "react-router-dom";

import PartnerLogo from "../../images/Partner-Managment.png";
import LeadLogo from "../../images/Lead-Management.png";
import ApplicationLogo from "../../images/Application.png";
import AccessLogo from "../../images/Access-Management.png";
import MasterLogo from "../../images/Master-Management.png";
import AdminProfile from "../../images/user_administrator.jpg";
import { useState } from "react";
import Logout from "../../containers/Pages/Login/Logout";
import { connect } from "react-redux";

function CETMobileHeader(props) {
  const [mobileMenu, setMobileMenu] = React.useState(false);

  const [open, setOpen] = useState(false);
  const hide = () => {
    setOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleMobileMenu = () => {
    setMobileMenu(!mobileMenu);
  };

  const onClose = () => {
    setMobileMenu(false);
  };

  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  return (
    <div className="cet-mobile-header">
      <Row className="side-br-mob">
        <Col xs={2}>
          <button
            className="hamburger-icon"
            type="primary"
            onClick={handleMobileMenu}
          >
            <MenuUnfoldOutlined />
            {/* <MenuFoldOutlined />
             */}
          </button>
        </Col>
        <Col xs={7}>
          <div className="log-avs">
            <img src={Logo} alt="" width={100} height={40} />
          </div>
        </Col>
        <Col xs={3} className="cet-mobile-header-login">
          <div className="login-profie">
            <div className="img-sec">
              <Popover
                color={"white"}
                content={
                  <div>
                    <h4>{props.userDetail?.userName}</h4>
                    <h5 className="mb-3">{props.userDetail?.roleName}</h5>
                    <Logout hide={hide} />
                  </div>
                }
                placement="bottomRight"
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
              >
                <div className="img-sec-mobile">
                  <h2>
                    {adminFirstName(
                      props.userDetail?.firstName ??
                        props.userDetail?.userName?.split(" ")[0]?.trim()
                    )}
                  </h2>
                  <h2>
                    {adminLastName(
                      props.userDetail?.lastName ??
                        props.userDetail?.userName?.split(" ")[1]?.trim()
                    )}
                  </h2>
                </div>
                {/* <img className="iconLog" src={AdminProfile} alt="" /> */}
              </Popover>
            </div>
          </div>
        </Col>
      </Row>

      <Drawer
        open={mobileMenu}
        onClose={onClose}
        placement="left"
        width={300}
        className="cet-mobile-header-drawer"
      >
        <div className="log-avs">
          <img src={Logo} alt="" />
        </div>
        <div className="list-contnt">
          <ul className="list">
            <li className="" onClick={onClose}>
              <Link className="ListItem" to="/CETDashboard/PartnerManagement">
                <img src={PartnerLogo} alt="" className="sidebarIcon" />
                <span className="list-Text"> Partner Management</span>
              </Link>
            </li>

            {/* <li onClick={onClose}>
              <p>
                <Link className="ListItem" to="/CETDashboard/LeadManagement">
                  <img src={LeadLogo} alt="" className="sidebarIcon" />
                  <span className="list-Text">Lead Management</span>
                </Link>
              </p>
            </li> */}
            {/* <li onClick={onClose}>
              <Link className="ListItem" to="/CETDashboard/ApplicationsListing">
                <img src={ApplicationLogo} alt="" className="sidebarIcon" />
                <span className="list-Text">Applications Listing</span>
              </Link>
            </li> */}

            <li onClick={onClose}>
              <Link className="ListItem" to="/CETDashboard/AccessManagement">
                <img src={AccessLogo} alt="" className="sidebarIcon" />
                <span className="list-Text">Access Management</span>
              </Link>
            </li>
            {/* <li onClick={onClose}>
              <Link className="ListItem" to="/CETDashboard/MasterManagement">
                <img src={MasterLogo} alt="" className="sidebarIcon" />
                <span className="list-Text">Master Management</span>
              </Link>
            </li> */}
            <li onClick={onClose}>
              <Link className="ListItem" to="/CETDashboard/PartnerPricing">
                <img src={AccessLogo} alt="" className="sidebarIcon" />
                <span className="list-Text">Partner Pricing/ Recovery</span>
              </Link>
            </li>
          </ul>
        </div>
      </Drawer>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    access_token: state.auth?.idToken,
    data: state.teamSideBar,
    partnerSidebarDtoList: state.partnerSidebar?.partnerSidebarDtoList,
    userData: state.auth?.userData,
    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId ||
      sessionStorage.getItem("cetFirmId"),
    userDetail: state.auth?.userData,
  };
};

export default connect(mapStateToProps)(CETMobileHeader);
